import PropTypes from 'prop-types';
import React from 'react';
import { Tooltip } from 'react-tippy';
import styled, { createGlobalStyle } from 'styled-components';
import SVG from 'react-inlinesvg';
import 'react-tippy/dist/tippy.css';

import colors from 'shared-assets/lib/colors';

const GlobalStyle = createGlobalStyle`
  .tippy-tooltip [x-circle] {
    background-color: ${colors.secondary};
  }

  .tippy-tooltip {
    background-color: ${colors.secondary};
    border-radius: 4px;
    max-width: 280px;
    padding: 0.5rem 1rem;
    line-height: 1rem;
  }

  .tippy-tooltip-content {
    font-size: 0.75rem;
    color: #fff;

    p {
      text-align:left;
    }
  }
`;

const InfoIconWrapper = styled.section`
  position: relative;
  width: 1.5rem;
  height: 1rem;

  .isvg {
    align-items: center;
    display: flex;
    margin: 0 0.25rem;
  }

  svg {
    width: 1rem;
    height: 1rem;
    fill: ${props => props.color};
    position: relative;
    z-index: 2;
  }
`;

const InfoIcon = props => (
  <InfoIconWrapper
    className="info-icon--wrapper"
    color={props.color}
    data-testid="icon-message"
  >
    <Tooltip
      animation="none"
      animateFill={false}
      duration={0}
      interactive={props.interactive}
      open={props.open}
      position={props.position}
      title={props.message}
      html={props.html}
      stickyDuration={0}
      style={props.style}
      distance={props.distance}
    >
      <span>
        <SVG
          cacheGetRequests
          src={require('shared-assets/assets/icons/question.svg')}
        />
      </span>
    </Tooltip>
    <GlobalStyle />
  </InfoIconWrapper>
);

export default InfoIcon;

InfoIcon.defaultProps = {
  color: colors.secondary,
  interactive: undefined,
  open: undefined,
  position: 'top',
  style: {},
  message: undefined,
  html: undefined,
  distance: 10,
};

InfoIcon.propTypes = {
  color: PropTypes.string,
  message: PropTypes.string,
  html: PropTypes.element,
  interactive: PropTypes.bool,
  open: PropTypes.bool,
  position: PropTypes.oneOf(['top', 'right', 'bottom', 'left']),
  style: PropTypes.object,
  distance: PropTypes.number,
};
